import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Space } from "@/react/types";
import { useCongratulationsModal } from "../Content/CongratulationsModal";
import { LESSON_STATUS } from "../constants";
import { useNavigateToNextLesson } from "./useNavigateToNextLesson";

export interface LessonParams {
  lessonId: string;
}
interface CompleteLessonMutationProps {
  refetchLesson: () => any;
  refetchSpace: () => any;
  skipNavigation?: boolean;
  space?: Space;
}

export const useCompleteLessonMutation = ({
  space,
  refetchSpace,
  refetchLesson,
  skipNavigation = false,
}: CompleteLessonMutationProps) => {
  const params = useParams<LessonParams>();
  const congratulationsModal = useCongratulationsModal();
  const { navigateToNextLesson, shouldShowCongratulationsModal } =
    useNavigateToNextLesson({
      space,
      refetchSpace,
    });

  return useMutation(
    () =>
      reactQueryPatch(
        internalApi.courses.lessonProgress.update({
          courseId: space?.id,
          lessonId: params.lessonId,
        }),
        {
          status: LESSON_STATUS.COMPLETED,
        },
      ),
    {
      onSuccess: () => {
        if (skipNavigation) {
          void refetchLesson();
          void refetchSpace();
        } else {
          if (shouldShowCongratulationsModal) {
            void refetchLesson();
            void refetchSpace();
            void congratulationsModal.show({ space });
          } else {
            void navigateToNextLesson();
          }
        }
      },
    },
  );
};
